/**
 * WorkingVeil - Full-screen overlay with spinner for long operations
 * 
 * Displays "Crunching the numbers..." message with spinner during
 * operations like meal plan scheduling.
 */

import React from 'react';
import PropTypes from 'prop-types';
import './WorkingVeil.scss';

const WorkingVeil = ({ isVisible, message = "Crunching the numbers..." }) => {
    if (!isVisible) {
        return null;
    }

    return (
        <div className="working-veil">
            <div className="working-veil-content">
                <i className="icon-spinner2 spinner" />
                <h2>{message}</h2>
                <i className="icon-calendar5" />
            </div>
        </div>
    );
};

WorkingVeil.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    message: PropTypes.string
};

export default WorkingVeil;